import { ModalConfig } from './LandingPageMultiStepModalTypes';
import { jsonToHtml, selectFromDocument, hasText, hasAttribute } from '../Utils/DOMUtils';

// The texts within this modal are taken from an endpoint. Hydrate the modal on page load.
const hydrateModalContent = (labels: ModalConfig) => {
    // Headers
    const authorName = selectFromDocument('.landing-page-multistep-modal-header .author-name');
    const authorRole = selectFromDocument('.landing-page-multistep-modal-header .author-role');
    const authorAvatar = selectFromDocument('.landing-page-multistep-modal-header .author-avatar img');

    if (!hasAttribute(authorAvatar, 'src')) {
        authorAvatar.setAttribute('src', labels.contactProfilePicture);
    }
    if (!hasText(authorName)) {
        authorName.innerHTML = labels.contactProfileName;
    }
    if (!hasText(authorRole)) {
        authorRole.innerHTML = labels.contactProfileInfo;
    }

    // intro
    const introText = selectFromDocument('.landing-page-multistep-modal-content.step-one .intro-text');
    const introButtonText = selectFromDocument('.landing-page-multistep-modal-content.step-one .landing-page-multistep-modal-btn');

    if (!hasText(introText)) {
        introText.innerHTML = jsonToHtml(labels.step1IntroText);
    }

    if (!hasText(introButtonText)) {
        introButtonText.innerHTML = labels.step1ButtonText;
    }

    const stepOnePostcodeLabel = selectFromDocument('.landing-page-multistep-modal-content.step-two .postcode-form-label');
    const stepOnePostcodeInput = selectFromDocument('.landing-page-multistep-modal-content.step-two .postcode-text-input');

    stepOnePostcodeLabel.innerHTML = labels.step2PostcodeField.caption;
    stepOnePostcodeInput.setAttribute('placeholder', labels.step2PostcodeField.settings.Placeholder as string);

    const stepOneNameLabel = selectFromDocument('.landing-page-multistep-modal-content.step-two .name-form-label');
    const stepOneNameInput = selectFromDocument('.landing-page-multistep-modal-content.step-two .name-text-input');

    stepOneNameLabel.innerHTML = labels.step2NameField.caption;
    stepOneNameInput.setAttribute('placeholder', labels.step2NameField.settings.Placeholder as string);

    const stepOneEmailLabel = selectFromDocument('.landing-page-multistep-modal-content.step-two .email-form-label');
    const stepOneEmailInput = selectFromDocument('.landing-page-multistep-modal-content.step-two .email-text-input');
    const stepOneSubmitButton = selectFromDocument('.landing-page-multistep-modal-content.step-two .landing-page-multistep-modal-btn');

    if (!hasText(stepOneSubmitButton)) {
        stepOneSubmitButton.innerHTML = jsonToHtml(labels.step2ButtonText);
    }

    stepOneEmailLabel.innerHTML = labels.step2EmailField.caption;
    stepOneEmailInput.setAttribute('placeholder', labels.step2EmailField.settings.Placeholder as string);

    // step 2
    const stepTwoIntroText = selectFromDocument('.landing-page-multistep-modal-content.step-two .intro-text');
    const stepTwoThankyouText = selectFromDocument('.landing-page-multistep-modal-content.step-three .intro-text');
    const stepTwoThankyouButton = selectFromDocument('.landing-page-multistep-modal-content.step-three .landing-page-multistep-modal-btn');

    if (!hasText(stepTwoIntroText)) {
        stepTwoIntroText.innerHTML = jsonToHtml(labels.step2IntroText);
    }
    if (!hasText(stepTwoThankyouText)) {
        stepTwoThankyouText.innerHTML = jsonToHtml(labels.step2ThankYouText);
    }
    if (!hasText(stepTwoThankyouButton)) {
        stepTwoThankyouButton.innerHTML = labels.step2ThankYouButtonText;
    }

    // step 3
    const stepThreePhoneLabel = selectFromDocument('.landing-page-multistep-modal-content.step-four .phone-form-label');
    const stepThreePhoneInput = selectFromDocument('.landing-page-multistep-modal-content.step-four .phone-form-input');
    const stepThreeThankyouButton = selectFromDocument('.landing-page-multistep-modal-content.step-five .landing-page-multistep-modal-btn');

    if (!hasText(stepThreePhoneLabel)) {
        stepThreePhoneLabel.innerHTML = labels.step3PhoneField.caption;
        stepThreePhoneInput.setAttribute('placeholder', labels.step3PhoneField.settings.Placeholder as string);
    }

    if (!hasText(stepThreeThankyouButton)) {
        stepThreeThankyouButton.innerHTML = labels.step3ThankYouButtonText;
    }

    const stepThreeDetailsLabel = selectFromDocument('.landing-page-multistep-modal-content.step-four .details-label');
    const stepThreeDetailsInput = selectFromDocument('.landing-page-multistep-modal-content.step-four .details-input');

    if (!hasText(stepThreeDetailsLabel)) {
        stepThreeDetailsLabel.innerHTML = labels.step3DetailsField.caption;
        stepThreeDetailsInput.setAttribute('placeholder', labels.step3DetailsField.settings.Placeholder as string);
    }
    const stepThreeIntroText = selectFromDocument('.landing-page-multistep-modal-content.step-four .intro-text');

    if (!hasText(stepThreeIntroText)) {
        stepThreeIntroText.innerHTML = labels.step3IntroText;
    }
    const stepThreeSubmitButton = selectFromDocument('.landing-page-multistep-modal-content.step-four .landing-page-multistep-modal-btn');

    if (!hasText(stepThreeSubmitButton)) {
        stepThreeSubmitButton.innerHTML = labels.step3ButtonText;
    }

    const formSuccessMessage = selectFromDocument('.landing-page-multistep-modal-content.form-end .notification-success .notif-content');
    const formErrorMessage = selectFromDocument('.landing-page-multistep-modal-content.form-end .notification-error .notif-content');

    if (!hasText(formErrorMessage)) {
        formErrorMessage.innerHTML = labels.formErrorMessage;
    }

    if (!hasText(formSuccessMessage)) {
        formSuccessMessage.innerHTML = labels.formSuccessMessage;
    }
};

export default hydrateModalContent;
